export default "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__";